import { models } from '@kurtosys/ksys-app-template';
import { IAppConfigurationBase } from '../models/app/IAppConfigurationBase';

export const APPLICATION_CLIENT_CONFIGURATIONS: models.api.applicationManager.IApplicationClientConfiguration[] = [
	{
		applicationClientConfigurationId: 1,
		configuration: {
			culture: {
				base: 'Default',
				default: 'en-GB',
			},
			core: {
				inputs: {
					queries: [
						{
							queryId: 'urlPattern',
							queryOptionsType: 'none',
							value: '/:fundId',
						},
						{
							queryId: 'urlFundId',
							queryOptionsType: 'url',
							code: 'param',
							urlPattern: {
								queryOptionsType: 'input',
								key: 'urlPattern',
							},
							key: 'fundId',
						},
					],
				},
				embedding: {
					hostname: 'https://api-local.fundpress.io/',
					embeds: [
						{
							embedId: 'entity-explorer',
							templateId: 'ksys-app-entity-explorer',
							applicationCode: '2f750298-ed9f-40b3-bee5-d4b550fed278',
						},
					],
				},
			},
			data: {
				context: {
					entityByType: {
						FUND: {
							inputKey: 'urlFundId',
							clientCodeProperty: 'fund_code',
							include: {
								commentaries: {},
							},
						},
						CLSS: {
							inputKey: 'isin',
							clientCodeProperty: 'isin',
							include: {
								commentaries: {},
							},
						},
					},
				},
			},
			accessibilityConfig: {
				asset: {
					base: {
						accordionPanel: {
							collapseIcon: {
								value: 'Button to close the panel',
							},
							expandIcon: {
								value: 'Button to open the panel',
							},
						},
					},
				},
				tables: {
					performance: {
						caption: {
							value: 'Past Performance',
						},
					},
				},
			},
		} as IAppConfigurationBase,
		name: 'root',
		applicationClientConfigurationTypeId: 1,
	},
];
